var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalenderFilled = function SvgCalenderFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3440",
    d: "m12.242 2.183-.425-.025v-1.1a.747.747 0 0 0-.75-.75.747.747 0 0 0-.75.75v1A51 51 0 0 0 8.05 2q-1.212.002-2.425.067V1.058a.747.747 0 0 0-.75-.75.747.747 0 0 0-.75.75v1.109c-.091 0-.175.008-.266.016C2.392 2.325.95 3.675.667 5.133h14.767c-.284-1.458-1.725-2.808-3.192-2.95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3440",
    fillRule: "evenodd",
    d: "M.542 6.383h15a34.6 34.6 0 0 1-.075 5.8c-.167 1.542-1.692 3.017-3.233 3.167a50.3 50.3 0 0 1-8.384 0C2.317 15.2.784 13.725.617 12.183a34.6 34.6 0 0 1-.075-5.8m3.183 4.825c.625.034 1.259.034 1.892 0a.94.94 0 0 0 .85-.85 18 18 0 0 0 0-1.891.94.94 0 0 0-.85-.85 18 18 0 0 0-1.892 0 .94.94 0 0 0-.85.85 18 18 0 0 0 0 1.891.94.94 0 0 0 .85.85",
    clipRule: "evenodd"
  })));
};
export default SvgCalenderFilled;